// University aliases data imported from JSON
// This provides search aliases like "TUM" for "Technische Universität München"

export interface UniversityAliasData {
  name: string
  aliases: string[]
  domains: string[]
}

// Import the JSON data from assets
import aliasesData from '@/assets/university_domains.json'

export const universityAliases: Map<string, string[]> = new Map()

// Build the aliases map
aliasesData.forEach((item: UniversityAliasData) => {
  const normalizedName = item.name.toLowerCase()
  universityAliases.set(normalizedName, item.aliases.map(a => a.toLowerCase()))
})

/**
 * Get aliases for a university name
 */
export function getUniversityAliases(universityName: string): string[] {
  const normalized = universityName.toLowerCase()
  return universityAliases.get(normalized) || []
}

/**
 * Check if a query matches any alias of a university
 */
export function matchesAlias(universityName: string, query: string): boolean {
  const aliases = getUniversityAliases(universityName)
  const lowerQuery = query.toLowerCase()
  
  return aliases.some(alias => 
    alias.toLowerCase().includes(lowerQuery) || 
    lowerQuery.includes(alias.toLowerCase())
  )
}
